<template>
  <div class="grid gap-2 grid-cols-5 md:grid-cols-12">
    <div class="flex-none" v-for="(item, index) in items.banners" :key="index">
      <div class="flex flex-col items-center gap-2 cursor-pointer text-center" @click="useBannerAction(item, items.header,index)">
        <NuxtImg :src="item.content.source" :class="classes" :lazy="true" alt="Gallery image" title="Gallery image"/>
        <template v-if="config.tag && item.meta?.tag">
          <p class="absolute bottom-0 p-0.5 bg-green-500 text-xs text-nowrap text-white line-clamp-2">
            {{ item.meta?.tag }}
          </p>
        </template>
        <div class="flex flex-col">
          <h5 v-if="config.title" class="break-words text-xs md:text-sm lg:text-sm line-clamp-3">
            {{ item.meta?.title }}
          </h5>
          <h6 v-if="config.sub_title" class="break-all text-sm text-wrap text-gray-700 dark:text-gray-200 line-clamp-2">
            {{ item.meta?.sub_title }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { isMobile } = useDevice();
const props = defineProps(['items', 'config', 'layout']);

const isSquare = props.layout === 'square';
const classes = [
  'object-contain',
  isMobile ? 'h-[70px] w-28' : 'h-[100px] w-32',
  isSquare ? 'rounded-md' : 'rounded-full',
  props.config.border ? '' : ''
];
</script>
